(function () {
  if (typeof window === 'undefined') {
    return;
  }

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js-el-animate');
  var animatedElements = Array.prototype.slice.call(document.querySelectorAll('[data-el-animate]'));

  if (animatedElements.length === 0) {
    return;
  }

  if (prefersReduced || !('IntersectionObserver' in window)) {
    animatedElements.forEach(function (el) {
      el.classList.add('el-animate--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        return;
      }

      var element = entry.target;
      var delay = parseInt(element.getAttribute('data-el-delay'), 10) || 0;
      if (delay > 0) {
        window.setTimeout(function () {
          element.classList.add('el-animate--visible');
        }, delay);
      } else {
        element.classList.add('el-animate--visible');
      }

      obs.unobserve(element);
    });
  }, {
    threshold: 0.15
  });

  animatedElements.forEach(function (element) {
    observer.observe(element);
  });
})();
